import { render, staticRenderFns } from "./newszhaonai.vue?vue&type=template&id=2b602504&scoped=true&"
import script from "./newszhaonai.vue?vue&type=script&lang=js&"
export * from "./newszhaonai.vue?vue&type=script&lang=js&"
import style0 from "./newszhaonai.vue?vue&type=style&index=0&id=2b602504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b602504",
  null
  
)

export default component.exports